import * as history from 'history'

const browserHistory = history.createBrowserHistory()

export default browserHistory
